import React from 'react';
import { Button } from 'react-bootstrap';
import './PrintOverviewPage.scss';
import CustomTable from '../Table/CustomTable';

const PrintOverviewSection = ({
  currentControlStrategyConfigurations,
  chartStage,
  currentParameter,
  unit,
  summaryStatisticsColumns,
  summaryStatisticsPreview,
  pageSizeDefault,
  summaryStatisticsPreviewTwo,
  renderEditTable,
  renderPrintOverviewCharts,
  handleBackToOverview
}) => {
  const summaryStatisticsColumnsPrint = summaryStatisticsColumns.map((col) =>
    col.field === 'statistic' ? { ...col, flex: 1 } : col
  );

  return (
    <>
      <div>
        <div>
          <div>
            <div>
              <div>
                <div className="header">
                  <h2>Overview</h2>
                </div>
                <div className="underline-header">
                  <hr />
                </div>
                <div className="chart-status-section">
                  {currentControlStrategyConfigurations.controlStatus === 'No' ? (
                    <>
                      <div>
                        <h3>Chart Stage: Active</h3>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <h3>Chart Stage: {chartStage}</h3>
                      </div>
                    </>
                  )}
                </div>
                <div className="overview-chart-header">
                  <h4>
                    Summary Statistics: {currentParameter}, {unit}
                  </h4>
                </div>
                <div className="statistics-row-section">
                  <div>
                    <CustomTable
                      header={summaryStatisticsColumnsPrint}
                      data={summaryStatisticsPreview}
                      numberOfRows={pageSizeDefault}
                      hideFooter={true}
                      hideHeader={true}
                    />
                  </div>
                  <div>
                    <CustomTable
                      header={summaryStatisticsColumnsPrint}
                      data={summaryStatisticsPreviewTwo}
                      numberOfRows={pageSizeDefault}
                      hideFooter={true}
                      hideHeader={true}
                    />
                  </div>
                </div>
                <div className="edit-table-section">{renderEditTable()}</div>
              </div>
            </div>
            <div />
          </div>
        </div>
        {renderPrintOverviewCharts()}
      </div>
      <div className="print-button-container">
        <Button onClick={handleBackToOverview}>Back</Button>
      </div>
    </>
  );
};

export default PrintOverviewSection;
